import { ApiCore } from './utilities/core'


export const conversationsChartsAPI = (tenantSlug: string) => {
    return new ApiCore({
        getAll: true,
        getSingle: true,
        url: `api/${tenantSlug}/charts`
    })
};